<template>
  <section class="black-friday-hero">
    <div
      :class="[
        'black-friday-hero__content',
        isBlackFridayPage && 'black-friday-hero__content--mt-10',
      ]"
    >
      <div class="black-friday-hero__logo" @click="redirectToBlackFriday">
        <h1 class="black-friday-hero__maintitle" v-if="isCyberMondayActive">
          BLACK FRIDAY & CYBER MONDAY
        </h1>
        <h1 v-else class="black-friday-hero__maintitle">BLACK FRIDAY</h1>
        <h2 class="black-friday-hero__subtitle">DEALS ARE BACK</h2>
      </div>
      <div @click="redirectToBlackFriday">
        <div class="black-friday-hero__title">Choose your own training adventure.</div>
        <div
          :class="[
            'black-friday-hero__intro',
            isCyberMondayActive && 'black-friday-hero__intro-smaller',
          ]"
        >
          <span v-if="isCyberMondayActive">
            Dive into Black Friday and Cyber Monday deals to discover the perfect training plan for
            individual learners!
          </span>
          <span v-else>
            Dive into Black Friday deals to discover the perfect training plan for individual
            learners!
          </span>
        </div>
      </div>
      <div v-if="!isBlackFridayPage">
        <router-link :to="{ name: 'black-friday' }" class="btn btn--primary btn--full-mobile">
          Shop savings
        </router-link>
      </div>
      <div class="black-friday-hero__links-wrapper" v-if="isBlackFridayPage">
        <router-link :to="{ name: 'shop' }" class="btn btn--secondary btn--full-mobile">
          See standard pricing
        </router-link>
        <a
          :href="enterprisePromoUrl"
          class="btn btn--secondary btn--full-mobile"
          target="_blank"
          rel="noopener noreferrer"
        >
          Go to Enterprise deals
        </a>
      </div>
    </div>
    <div class="black-friday-hero__logo-wrapper" @click="redirectToBlackFriday">
      <CyberMondayLogo v-if="isCyberMondayActive" />
      <BLLogo v-else />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BLLogo from '@/assets/images/hero-section/black-friday/bl-logo.svg'
import CyberMondayLogo from '@/assets/images/hero-section/cyber-monday/cm-logo.svg'
import { routesRules, promoProductBundleUtils } from '@/helpers/mixins'
import CONSTANTS from '@/constants'

const {
  LINKS: { PROMO_2024_EOY_ENTERPRISE },
} = CONSTANTS

export default {
  name: 'BlackFridayHeroSection',
  mixins: [routesRules, promoProductBundleUtils],
  components: {
    BLLogo: { ...BLLogo, name: 'BLLogo' },
    CyberMondayLogo: { ...CyberMondayLogo, name: 'CyberMondayLogo' },
  },
  data() {
    return {
      enterprisePromoUrl: PROMO_2024_EOY_ENTERPRISE,
    }
  },
  methods: {
    redirectToBlackFriday() {
      if (!this.isBlackFridayPage) {
        this.$router.push({ name: 'black-friday' })
      }
    },
  },
  computed: {
    ...mapGetters({
      isCyberMondayActive: 'app/isCyberMondayActive',
    }),
  },
}
</script>

<style lang="scss" scoped>
.black-friday-hero {
  width: 100%;
  max-width: 1120px;
  padding: 20px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  position: relative;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;

  @include mobile {
    margin: 80px auto;
    padding: 0 30px;
    flex-direction: row;
  }
  @include tablet {
    margin: 0 auto 30px auto;
  }

  &__links-wrapper {
    display: flex;
    gap: 10px;
    flex-direction: column;

    @include mobile {
      flex-direction: row;
    }
  }

  &__maintitle {
    color: var(--white, #fff);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: rem(50px);
    font-style: italic;
    font-weight: 700;
    margin: 0;
    @include mobile {
      font-size: rem(48px);
      font-style: italic;
      font-weight: 700;
      line-height: rem(61px);
    }
    @include tablet {
      margin: 0 0 10px 0;
      font-size: rem(72px);
      font-style: italic;
      font-weight: 700;
    }
  }
  &__subtitle {
    color: var(--orange-mid);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: rem(40px);
    font-style: italic;
    font-weight: 700;
    line-height: rem(36px);
    margin: 0;
    @include mobile {
      font-size: rem(48px);
      font-style: italic;
      font-weight: 700;
      line-height: rem(50px);
    }
    @include tablet {
      font-size: rem(54px);
      font-style: italic;
      font-weight: 700;
      line-height: rem(50px);
    }
  }

  &__title {
    cursor: pointer;
    font-family: var(--font-bold);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(24px);
    margin-top: 20px;
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 0;
    }
    @include mobile {
      font-size: rem(20px);
      line-height: rem(26px);
      margin-top: 0;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    flex-flow: column;
    z-index: 1;
    &--mt-10 {
      margin-top: 10%;
      @include mobile {
        margin: 0;
        padding: 0;
      }
    }
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      gap: 0;
    }
    @include mobile {
      gap: 10px;
      max-width: 571px;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      gap: 0;
    }
    @include desktop {
      width: 95%;
      max-width: 568px;
    }
  }

  &__intro {
    cursor: pointer;
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    margin-bottom: 20px;

    @include tablet-ipad-air-and-mini-portrait {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 100%;
      &-smaller {
        font-size: rem(20px);
        line-height: rem(26px);
      }
    }
    @include mobile {
      color: var(--light-blue-gray);
      font-size: rem(20px);
      line-height: rem(26px);
      &-smaller {
        font-size: rem(20px);
        line-height: rem(26px);
      }
    }
    @include tablet {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      &-smaller {
        font-size: rem(20px);
        line-height: rem(26px);
      }
    }
  }
  &__logo {
    cursor: pointer;
  }
  &__logo-wrapper {
    cursor: pointer;
    width: 288px;
    height: 270px;
    resize: both;
    margin: 0;
    @include tablet {
      width: 280px;
      height: auto;
    }
    @include mobile {
      margin-left: 20px;
      width: 495px;
      height: auto;
      svg {
        width: 95%;
        height: 95%;
      }
    }
  }
}
</style>
